module.exports = __webpack_public_path__ + "static/media/0004t.846521e4.jpg";